import request from '@/utils/request'

const state = {
    userId: null,
    username: null,
    realName: null,
    permissions: [],  // 初始化为空数组
    roles: [],
    organizations: [],
    dataScope: 0,
    isSuperAdmin: false
}

const getters = {
    // 便捷 getter：判断是否超级管理员
    isSuperAdmin: state => state.isSuperAdmin || state.permissions.includes('*:*:*'),
    // 便捷 getter：获取用户显示名
    displayName: state => state.realName || state.username || '用户'
}

const mutations = {
    SET_USER_ID: (state, userId) => { state.userId = userId },
    SET_USERNAME: (state, username) => { state.username = username },
    SET_REAL_NAME: (state, realName) => { state.realName = realName },
    SET_PERMISSIONS: (state, permissions) => { state.permissions = permissions || [] },
    SET_ROLES: (state, roles) => { state.roles = roles || [] },
    SET_ORGANIZATIONS: (state, organizations) => { state.organizations = organizations || [] },
    SET_DATA_SCOPE: (state, dataScope) => { state.dataScope = dataScope || 0 },
    SET_IS_SUPER_ADMIN: (state, isSuperAdmin) => { state.isSuperAdmin = isSuperAdmin || false },
    // 清空所有用户状态（登出时调用）
    CLEAR_USER_STATE: (state) => {
        state.userId = null
        state.username = null
        state.realName = null
        state.permissions = []
        state.roles = []
        state.organizations = []
        state.dataScope = 0
        state.isSuperAdmin = false
    }
}

const actions = {
    getInfo({ commit }) {
        return new Promise((resolve, reject) => {
            request.get('/api/permission/info').then(response => {
                const data = response.data && response.data.data ? response.data.data : response.data
                commit('SET_USER_ID', data.userId)
                commit('SET_USERNAME', data.username)
                commit('SET_REAL_NAME', data.realName)
                commit('SET_PERMISSIONS', data.permissions || [])
                commit('SET_ROLES', data.roles || [])
                commit('SET_ORGANIZATIONS', data.organizations || [])
                commit('SET_DATA_SCOPE', data.dataScope || 0)
                commit('SET_IS_SUPER_ADMIN', data.superAdmin || false)
                resolve(data)
            }).catch(reject)
        })
    },
    /**
     * 从 localStorage 同步用户信息到 Vuex
     * 适用于已登录场景，避免重复请求接口
     */
    syncFromStorage({ commit }) {
        try {
            const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
            const permissions = JSON.parse(localStorage.getItem('permissions') || '[]')
            if (userInfo.userId || userInfo.id) commit('SET_USER_ID', userInfo.userId || userInfo.id)
            if (userInfo.username) commit('SET_USERNAME', userInfo.username)
            if (userInfo.realName) commit('SET_REAL_NAME', userInfo.realName)
            commit('SET_PERMISSIONS', permissions)
            commit('SET_IS_SUPER_ADMIN', permissions.includes('*:*:*'))
        } catch (e) {
            
        }
    },
    /**
     * 登出清理
     */
    logout({ commit }) {
        commit('CLEAR_USER_STATE')
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}